var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('c-avatar',_vm._g(_vm._b({},'c-avatar',_vm.avatarProps,false),_vm.$listeners),[_c('c-image',_vm._b({attrs:{"src":_vm.src,"error-src":_vm.errorSrc,"width":_vm.width,"height":_vm.height}},'c-image',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }